import React from 'react';
import Header from '../../website/component/Header';

const PublicRoute = ({ element: Component }) => {    
    return <>
        {/* <Header/> */}
        <Component />
    </>
};

export default PublicRoute;
